export const checkValidNumberWithoutDec = (number) => {
    return /^[0-9][0-9]*$/.test(number)
}